import { template } from 'lodash';
import axios from './client';

const SEARCH = '/marketing-materials-theme';
const CREATE = '/marketing-materials-theme';
const PIN = template('/marketing-materials-theme/<%= id %>/pin');
const UNPIN = template('/marketing-materials-theme/<%= id %>/unpin');
const DELETE = template('/marketing-materials-theme/<%= id %>');

export function search(payload = {}) {
  return axios.get(SEARCH, { params: payload });
}

export function create(payload = {}) {
  return axios.post(CREATE, payload);
}

export function pin(id) {
  return axios.post(PIN({ id }));
}

export function unpin(id) {
  return axios.post(UNPIN({ id }));
}

export function remove(id) {
  return axios.delete(DELETE({ id }));
}
